import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  className?: string;
}

export default function LanguageToggle({ className = '' }: LanguageToggleProps) {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko' || i18n.language.startsWith('ko');

  const toggle = () => {
    i18n.changeLanguage(isKo ? 'en' : 'ko');
  };

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-0.5 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-3 py-1.5 transition-all hover:bg-white/25 cursor-pointer ${className}`}
      aria-label="Toggle language"
    >
      <span className={`text-xs font-bold transition-colors ${isKo ? 'text-white' : 'text-white/40'}`}>KO</span>
      <span className="text-white/30 text-xs mx-0.5">/</span>
      <span className={`text-xs font-bold transition-colors ${!isKo ? 'text-white' : 'text-white/40'}`}>EN</span>
    </button>
  );
}

export function LanguageToggleDark({ className = '' }: LanguageToggleProps) {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko' || i18n.language.startsWith('ko');

  const toggle = () => {
    i18n.changeLanguage(isKo ? 'en' : 'ko');
  };

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-0.5 bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1.5 transition-all cursor-pointer ${className}`}
      aria-label="Toggle language"
    >
      <span className={`text-xs font-bold transition-colors ${isKo ? 'text-gray-900' : 'text-gray-400'}`}>KO</span>
      <span className="text-gray-300 text-xs mx-0.5">/</span>
      <span className={`text-xs font-bold transition-colors ${!isKo ? 'text-gray-900' : 'text-gray-400'}`}>EN</span>
    </button>
  );
}
